import { Link } from 'react-router-dom';
import { nip19 } from 'nostr-tools';

import { useAuthor } from '@/hooks/useAuthor';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';
import { safeUrl } from '@/lib/forum';

/** Inline author name that links to the user's NIP-19 profile. */
export function AuthorName({ pubkey, className }: { pubkey: string; className?: string }) {
  const author = useAuthor(pubkey);
  const meta = author.data?.metadata;
  const name = meta?.display_name || meta?.name || 'Anonymous';

  let npub = pubkey;
  try {
    npub = nip19.npubEncode(pubkey);
  } catch {
    npub = pubkey;
  }

  return (
    <Link to={`/${npub}`} className={cn('text-[#105B86] hover:underline font-semibold', className)}>
      {name}
    </Link>
  );
}

/** Author avatar pulled from profile metadata (URL sanitized). */
export function AuthorAvatar({
  pubkey,
  size = 'lg',
}: {
  pubkey: string;
  size?: 'sm' | 'default' | 'lg';
}) {
  const author = useAuthor(pubkey);
  const meta = author.data?.metadata;
  const name = meta?.display_name || meta?.name || 'Anon';
  const picture = meta?.picture ? safeUrl(meta.picture) ?? undefined : undefined;

  return (
    <Avatar size={size}>
      {picture ? <AvatarImage src={picture} alt={name} /> : null}
      <AvatarFallback>{name.slice(0, 2).toUpperCase()}</AvatarFallback>
    </Avatar>
  );
}
